<div class="client-profile-section">
  <div class="client-profile-overview-section">
    <img src="assets/user-profile.png" class="client-profile-image" />
    <p class="client-profile-name">
      {{ prospect_data.first_name }} {{ prospect_data.middle_name }}
      {{ prospect_data.last_name }}
    </p>
    <!-- <p class="client-profile-id">({{prospect_data.client_id}})</p> -->
    <!-- <div class="client-profile-member-section">
        <span class="client-profile-label">Opportunity:</span>
        <span class="client-profile-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{prospect_data.Opportunity}}</span>
      </div> -->
  </div>
  <div class="client-profile-details-block">
    <div class="client-products-tabs-section">
      <div
        class="each-client-products-tab"
        [ngClass]="{
          'each-client-products-tab-selected':
            selected_tab == 'Basic Information'
        }"
        (click)="selected_tab = 'Basic Information'"
      >
        <span>Basic Information</span>
      </div>
      <div
        class="each-client-products-tab"
        [ngClass]="{
          'each-client-products-tab-selected': selected_tab == 'Products'
        }"
        (click)="selected_tab = 'Products'"
      >
        <span>Products</span>
      </div>
    </div>
    <div *ngIf="selected_tab == 'Basic Information'">
      <div class="client-profile-details-section">
        <p class="client-profile-details-heading">Personal Information</p>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Email ID:</span>
          <span class="client-profile-value">{{ prospect_data.email }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Date of Birth:</span>
          <span class="client-profile-value">{{
            prospect_data.birth_date | date: "dd MMM yyyy"
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Gender:</span>
          <span class="client-profile-value">{{ prospect_data.gender }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Phone Number:</span>
          <span class="client-profile-value">{{
            prospect_data.telephone_number
          }}</span>
        </div>
      </div>
      <div class="client-profile-details-section">
        <p class="client-profile-details-heading">Contact Information</p>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Address:</span>
          <span class="client-profile-value">
            <span *ngIf="prospect_data.address_line_1"
              >{{ prospect_data.address_line_1 }},</span
            >
            <span *ngIf="prospect_data.address_line_2">{{
              prospect_data.address_line_2
            }}</span>
          </span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">City:</span>
          <span class="client-profile-value">{{ prospect_data.city }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">State:</span>
          <span class="client-profile-value">{{ prospect_data.state }}</span>
        </div>
        <!-- <div class="each-client-profile-detail-section">
            <span class="client-profile-label">Country:</span>
            <span class="client-profile-value">{{ prospect_data.country }}</span>
          </div> -->
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Zip Code:</span>
          <span class="client-profile-value">{{ prospect_data.zip_code }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Region:</span>
          <span class="client-profile-value">{{ prospect_data.region }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Resident Type:</span>
          <span class="client-profile-value">{{
            prospect_data.homeowner_or_renter
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Years in Residence:</span>
          <span class="client-profile-value">{{
            prospect_data.years_in_residence
          }}</span>
        </div>
      </div>
      <div class="client-profile-details-section">
        <p class="client-profile-details-heading">
          HouseHold & Behavioural Information
        </p>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Marital Status:</span>
          <span class="client-profile-value">{{
            prospect_data.maritial_status
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Adults in Household:</span>
          <span class="client-profile-value">{{
            prospect_data.adults_in_household
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Children in Household:</span>
          <span class="client-profile-value">{{
            prospect_data.children_in_household
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Household Income Range({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
          <span class="client-profile-value">{{
            prospect_data.household_income_in_dollars
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Individual Income({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
          <span class="client-profile-value">{{
            prospect_data.individual_income_in_dollars
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Real Estate Investor:</span>
          <span class="client-profile-value">
            <span *ngIf="prospect_data.real_estate_investor">Yes</span>
            <span *ngIf="!prospect_data.real_estate_investor">No</span>
          </span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Premium Credit Card Holder:</span>
          <span class="client-profile-value">
            <span *ngIf="prospect_data.premium_credit_card_holder">Yes</span>
            <span *ngIf="!prospect_data.premium_credit_card_holder">No</span>
          </span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Heavy Transactor:</span>
          <span class="client-profile-value">{{
            prospect_data.heavy_transactor
          }}</span>
        </div>
      </div>
      <div class="client-profile-details-section">
        <p class="client-profile-details-heading">Additional Info</p>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Occupation:</span>
          <span class="client-profile-value">{{ prospect_data.occupation }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Experience(Years):</span>
          <span class="client-profile-value"
            >{{ prospect_data.years_experience }} Years</span
          >
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Liquid Net Worth:</span>
          <span class="client-profile-value">{{ prospect_data.net_worth }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Total Net Worth:</span>
          <span class="client-profile-value">{{
            prospect_data.total_networth
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Source:</span>
          <span class="client-profile-value">{{ prospect_data.source }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Vehicle Type:</span>
          <span class="client-profile-value">{{
            prospect_data.vehicle_type
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Vehicle Count:</span>
          <span class="client-profile-value">{{
            prospect_data.vehicle_count
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Property Type:</span>
          <span class="client-profile-value">{{
            prospect_data.property_type
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Home Equity({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
          <span class="client-profile-value">{{
            prospect_data.home_equity_available_for_mortgage_in_dollars
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Loan to Value(%):</span>
          <span class="client-profile-value">{{
            prospect_data.loan_to_value_in_percentage
          }}</span>
        </div>
        <div class="each-client-profile-detail-section">
          <span class="client-profile-label">Market Value({{APP_CONSTANTS.CURRENCY_SYMBOL}}):</span>
          <span class="client-profile-value">{{
            prospect_data.market_value_of_home_in_dollars
          }}</span>
        </div>
      </div>
    </div>
    <div *ngIf="selected_tab == 'Products'">
        <div class="client-profile-details-section">
          <p class="client-profile-details-heading" style="font-weight: 800; color: #000000;">{{prospect_data.source}}</p>
          <ng-container *ngIf="prospect_data.source != 'Credit card'">
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Loan ID:</span>
              <span class="client-profile-value">{{ prospect_data.loan_id }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Loan Amount:</span>
              <span class="client-profile-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ prospect_data.loan_amount }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">FICO score:</span>
              <span class="client-profile-value">{{ prospect_data.fico }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Start Date:</span>
              <span class="client-profile-value">{{
                prospect_data.opendate | date: "dd MMM yyyy"
              }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Previous Payment Date:</span>
              <span class="client-profile-value">{{
                prospect_data.lastpaymentdate | date: "dd MMM yyyy"
              }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Tenure(months):</span>
              <span class="client-profile-value">{{ prospect_data.tenure }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Balance Amount:</span>
              <span class="client-profile-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{
                prospect_data.balance
              }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Default:</span>
              <span class="client-profile-value">{{
                prospect_data.default
              }}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="prospect_data.source == 'Credit card'">
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">FICO score:</span>
              <span class="client-profile-value">{{ prospect_data.fico }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Credit Limit:</span>
              <span class="client-profile-value">{{ prospect_data.credit_limit }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Balance Amount:</span>
              <span class="client-profile-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ prospect_data.balance }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Debt-to-Income Ratio:</span>
              <span class="client-profile-value">{{ prospect_data.dti }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Delinquencies in Last 2 Years:</span>
              <span class="client-profile-value">{{ prospect_data.delinq_2yrs }}</span>
            </div>
            <div class="each-client-profile-detail-section">
              <span class="client-profile-label">Inquiries in Last 6 Months:</span>
              <span class="client-profile-value">{{ prospect_data.inq_last_6mths }}</span>
            </div>
          </ng-container>
        </div>
    </div>
  </div>
</div>
